import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { environment } from '../../../environments/environment';
//import { DhhpAlertComponent } from '../../shared/dhhpalert/dhhpalert.component';
import { ApiService } from 'profile';
import { PHBHPListApiService, PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { AppConfig } from 'src/app/app.config';
import { Subscription } from 'rxjs';
import { TranslationKeys } from 'ph-bhp-localization';

//import { LayoutService } from '../services/layout.service';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit, OnDestroy {
  userprinciplename;
  clientId;
  clientSecret;
  subscriptionUser: Subscription;
  logOutUrl: string;
  packageInstitutionsList: Array<any>;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  
  constructor(private profileApiService: ApiService, public config: AppConfig, public service: PHBHPListApiService, public layoutService: PHBHPLayoutPackageService) { }

  ngOnInit() {
    if (this.config.userData) {
      this.userData()
    } else {
      this.subscriptionUser = this.config.userSubject.asObservable().subscribe(res => {
        this.userData()
      })
    }
    this.profileApiService.apiUrl = environment.apiUrl + '/api/';
    // this.clientId = environment.ClientId;
    // this.clientSecret = environment.ClientSecret;
    this.profileApiService.tokenKey = environment.loginAccesstok
    this.logOutUrl = environment.siteUrl + 'login';
  }
  userData() {
    this.userprinciplename = this.config.userData.externalAppUserId;
    var roleId = this.config.userData.roleName.roleId;
    var institutions = this.config.institutions;
    if (roleId != 1 && roleId != 2) {
      this.service.getInstitutionsbyId(institutions, roleId).subscribe((res: any) => {
        this.packageInstitutionsList = [];
        res.forEach(data => {
          this.packageInstitutionsList.push({
            id: data.institution.institutionID,
            label: data.institution.institutionName
          });
        });
      });
    }

  }
  onDataEvent(event) {
    switch (event.event) {
      case 'success': this.layoutService.showSuccess(this.layoutService.translateText('Success, Activation code sent to your email')); break;
      case 'failure': this.layoutService.showError(this.layoutService.translateText('Error when resetting password')); break;
      // case 'changePasswordSuccess': this.layoutService.showSuccess(this.layoutService.translateText(this.translationKeys.SuccessMessages.PasswordUpdated)); break;
      // case 'profileUpdateSuccess': this.layoutService.showSuccess(this.layoutService.translateText('AUTHORIZATION.PROFILE_INFORMATION_UPDATED_SUCCESSFULLY')); break;
      case 'changePasswordFailure': this.layoutService.showError(this.layoutService.translateText('ERROR_MESSAGES.ENTER_VALID_PASSWORD')); break;
      case 'deleteAccount': this.layoutService.showSuccess(this.layoutService.translateText('OTP sent successfully')); break;
      case 'suceessDel': this.layoutService.showSuccess(this.layoutService.translateText('Delete request sent successfully')); break;
      case 'failureDel': this.layoutService.showSuccess(this.layoutService.translateText('Wrong or expired OTP, Please re-enter')); break;
      case 'error': this.layoutService.showError(this.layoutService.translateText(event.message)); break;
      case 'profileMoifyError': this.layoutService.showError(this.layoutService.translateText(event.value)); break;
    }
  }

  ngOnDestroy() {
    if (this.subscriptionUser) {
      this.subscriptionUser.unsubscribe();
    }
  }

}
